import httpApi from '@/utils/http-api'
import { api } from '@/config'

export default {
  getAccountRegistrationSummary: (query) => {
    return httpApi.getDataViaApi({
      url: api.registration.getAccountRegistrationSummary,
      queryParams: query
    })
  },
  postRegisterData: (body) => {
    return httpApi.postDataViaApi({
      url: api.registration.postRegisterData,
      body
    })
  },
  uploadFile: (body) => {
    return httpApi.uploadFileViaApi({
      url: api.registration.fileUpload,
      body
    })
  },
  getSectionTrackingDetails: (query) => {
    return httpApi.getDataViaApi({
      url: api.registration.getSectionTrackingDetails,
      queryParams: query
    })
  },
  completeRegistrationProcess: (body) => {
    return httpApi.postDataViaApi({
      url: api.registration.completeRegistrationProcess,
      body
    })
  },
}
